/**
 * Agrivaknet JavaScript & CSS library.
 *
 * @author Wouter Schotman <wouter@ideemedia.nl>
 * @copyright IdeeMedia.nl
 */

import "../scss/style.scss";
import { onScroll } from "./scroll";
import { sliders } from "./sliders";
import { search } from "./search";
import { initializeMemberMap } from "./map";

function init()
{
	window.addEventListener("scroll", onScroll, {passive: true});
}

sliders();
search();
initializeMemberMap();
init();